/*eslint-disable*/
export const getFilteredUsers = (state) => state.users.filteredUsers
